export enum ActivityOrigin {
    Donor,
    Team,
    System,
}
